import React, { useState, useEffect } from 'react';
import SearchResultCard from '../Components/SearchCard';
import { getNonFeaturedSalons } from '../Common/requests';
import { useMediaQuery } from 'react-responsive';
import Slider from "react-slick";
import NotFound from '../assets/images/not-found.png';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const OtherSalons = () => {
    const { t } = useTranslation('marketplace');
    const isSlider = true; //useMediaQuery({ query: '(max-width: 991px)' });
    const [searching, setSearching] = useState(true);
    const [salons, setSalons] = useState([]);

    const settings = {
        //  dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        initialSlide: 0,
        responsive: [
            {
                //breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    async function fetchSalonsList() {
        setSearching(true);
        const response = await getNonFeaturedSalons();
        setSearching(false);
        setSalons(response?.featuredSaloons);
    }

    const sortOrder = ['PREMIUM', 'PREMIUM_PLAN_YEARLY', 'PREMIUM_PLAN_MONTHLY', 'BASIC_PLAN_YEARLY', 'BASIC_PLAN_MONTHLY', 'FREE'];

    const sortSalonList = (arr, desiredOrder) => {
        const orderForIndexVals = desiredOrder.slice(0).reverse();
        arr?.sort((a, b) => {
            const aIndex = -orderForIndexVals.indexOf(a.subscriptionType);
            const bIndex = -orderForIndexVals.indexOf(b.subscriptionType);
            return aIndex - bIndex;
        });
    }

    useEffect(() => {
        fetchSalonsList();
    }, [])

    useEffect(() => {
        if (salons?.length > 0) {
            sortSalonList(salons, sortOrder);
        }
    }, [salons])

    const renderContent = () => {
        if (searching) {
            return (
                <div style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
                    {t('home.loadingVenues')}
                </div>
            );
        }

        if (salons?.length === 0) {
            return (
                <div className="not-found">
                    <img src={NotFound} alt="No salons found" />
                    {t('home.noSalonsFound')} <br /> {t('home.checkAgainSoon')}
                </div>
            );
        }

        return isSlider ? (
            <Slider key={`slider-${salons?.length}`} {...settings}>
                {salons?.map((item) => (
                    <div className="item" key={item.id || item.businessId} >
                        <SearchResultCard item={item} />
                    </div>
                ))}
            </Slider>
        ) : (
            <div className="flex">
                <div className="results">
                    <Row>
                        {salons?.map((item) => (
                            <Col lg={3} md={4} sm={6} key={item.id || item.businessId}>
                                <SearchResultCard item={item} />
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        );
    }

    return (
        <div className="search-page">
            <section className="search-results">
                <div className="container">
                    <h3 className="section-title">{t('home.otherVenues')}</h3>
                    {renderContent()}
                </div>
            </section>
        </div>
    );
}

export default OtherSalons;
